import { render, staticRenderFns } from "./SiteKeywordsConfirmModal.vue?vue&type=template&id=2221ca20&"
import script from "./SiteKeywordsConfirmModal.vue?vue&type=script&lang=js&"
export * from "./SiteKeywordsConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./SiteKeywordsConfirmModal.vue?vue&type=style&index=0&id=2221ca20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports